"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGRadio = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Radio.scss");

var _ErrorMessage = require("../../Global/ErrorMessage/ErrorMessage");

var BHGRadio = function BHGRadio(props) {
  var options = props.options,
      value = props.value,
      _onChange = props.onChange,
      className = props.className,
      horizontal = props.horizontal,
      label = props.label,
      error = props.error;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bhg-radio " + (horizontal ? "horizontal" : "") + (className ? className : "")
  }, label && /*#__PURE__*/_react.default.createElement("label", null, label), options.map(function (x) {
    return /*#__PURE__*/_react.default.createElement("label", {
      className: "radio"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      value: x.id,
      checked: value.includes(x.id),
      onChange: function onChange(e) {
        return _onChange(Number(e.target.value));
      }
    }), /*#__PURE__*/_react.default.createElement("span", null, x.optionText));
  }), error && /*#__PURE__*/_react.default.createElement(_ErrorMessage.BHGErrorMessage, {
    message: error
  }));
};

exports.BHGRadio = BHGRadio;
BHGRadio.defaultProps = {
  options: [],
  value: [],
  onChange: function onChange(e) {
    return console.log(e);
  },
  className: null,
  horizontal: false
};